import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IdService {
  private readonly defaultIdLength = 8;
  private readonly allowedCharsForId =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  public createId(len = this.defaultIdLength, chars = this.allowedCharsForId): string {
    let text = '';

    for (let i = 0; i < len; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return text;
  }
}
